<template>
  <div class="messRate">
    <el-slider v-model="rateValue_" @change="change"></el-slider>
    <div>{{rateValue_}}分</div>
  </div>
</template>

<script>

export default {
  name: "messRate",
  props: {
    rateValue: {
      type: Number
    },
  },
  data() {
    return {
      rateValue_: this.rateValue
    };
  },
  computed: {
    // rateValue_: {
    //   get() {
    //     return this.rateValue
    //   },
    //   set(val) {
    //    this.$emit("getMessForm",val)
    //   }
    // }
  },
  created() {
    this.$emit("getMessForm", this.rateValue_)
  },
  methods: {
    change(val) {
      this.$emit("getMessForm", val)
    },
  }

};

</script>
<style lang="less" scoped>
.messRate {
  width: 85%;
  margin: 0 auto;
}
/deep/.el-slider {
  width: 76%;
  float: left;
  margin-right: 20px;
  .el-slider__bar {
    background-color: #3994f0;
  }
  .el-slider__button {
    border: solid 2px #3994f0;
  }
}
</style>